import React, { useEffect, useState } from 'react';
import { 
  Shield,
  Lock,
  FileText,
  CheckCircle,
  AlertCircle,
  Info,
  Users,
  Building2,
  Scale,
  Database,
  UserCheck,
  Globe
} from 'lucide-react';

const AvisoPrivacidad = () => {
  const [direccion, setDireccion] = useState(null);

  useEffect(() => {
    fetch(`/data/generales.json?v=${Date.now()}`)
      .then(res => res.json())
      .then(data => setDireccion(data.contacto.direccion));
  }, []);
  const finalidadesPrimarias = [
    'Para contactarle con el propósito de ofrecerle nuestros servicios educativos.',
    'Para dar seguimiento a sus solicitudes de información sobre los servicios que ofrecemos.',
    'Para la aplicación de exámenes de admisión.',
    'Para enviarle publicidad y comunicaciones con fines de mercadotecnia, tele-marketing o campañas financieras.'
  ];

  const datosPersonales = [
    { tipo: 'Datos de identificación', ejemplos: 'Nombre, apellidos, edad, género' },
    { tipo: 'Datos de contacto', ejemplos: 'Teléfono, correo electrónico, dirección' },
    { tipo: 'Datos académicos', ejemplos: 'Nivel educativo, institución, área de estudio' },
    { tipo: 'Datos laborales', ejemplos: 'Empresa, puesto, experiencia profesional' }
  ];

  const terminosUso = [
    {
      titulo: 'Convenio',
      contenido: 'Convenio de adhesión para el uso de la página web: www.cenid.org (y subdominios) que celebran por una parte el CENID y, por la otra, el usuario, sujetándose, ambas partes, a lo establecido en este documento. El CENID otorga y concede al usuario el derecho no exclusivo, temporal, revocable y no transferible de observar, navegar y utilizar el sitio de conformidad con los términos y condiciones de uso que aquí se estipulan.'
    },
    {
      titulo: 'Contenidos y uso del sitio',
      contenido: 'El usuario se compromete a utilizar el sitio y todos sus contenidos conforme a las leyes aplicables, a lo dispuesto en este documento y con respeto al orden público. El usuario sólo podrá imprimir y/o copiar cualquier información contenida o publicada en el sitio exclusivamente para uso personal, queda estrictamente prohibido el uso comercial de dicha información.'
    },
    {
      titulo: 'Derechos de autor y propiedad industrial',
      contenido: 'El CENID, su sitio www.cenid.org (y subdominios), sus logotipos y todo el material que aparece en dicho sitio, son marcas, nombres de dominio, nombres comerciales y obras artísticas propiedad de sus respectivos titulares y están protegidos por los tratados internacionales y las leyes aplicables en materia de propiedad intelectual y derechos de autor.'
    }
  ];

  const responsabilidades = [
    'El uso, ejecución, retraso o falta de disponibilidad de uso del sitio.',
    'La proveeduría o falta de la misma de servicios de cualquier información o gráficos contenidos o publicados en o a través del sitio.',
    'La actualización o falta de actualización de la información.',
    'La alteración o modificación, total o parcial, de la información después de haber sido incluida en el sitio.',
    'Cualquier otro aspecto o característica de la información contenida o publicada en la página web o a través de las ligas que eventualmente se incluyan en este sitio.'
  ];

  const requisitosAlumnos = [
    'Al inscribirse un alumno se compromete con el reglamento y cuotas vigentes.',
    'No pueden presentar exámenes quienes estén atrasados en las colegiaturas.',
    'Es requisito indispensable que los alumnos acepten este aviso.',
    'Causará baja todo alumno que adeude tres o más colegiaturas y no podrá inscribirse en el ciclo escolar siguiente.',
    'El alumno deberá contar con su documentación completa y en regla.',
    'El alumno deberá llenar la Solicitud de Ingreso.',
    'El alumno deberá contar con una computadora con acceso a Internet y con conocimientos básicos de informática.'
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <div className="relative bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white py-20 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMSIvPjwvcGF0dGVybj48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNncmlkKSIvPjwvc3ZnPg==')] opacity-20"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-6">
          <div className="flex items-start gap-4 mb-6">
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
              <Shield className="w-12 h-12" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-4">
                Aviso de Privacidad
              </h1>
              <p className="text-xl md:text-2xl text-white/90">
                Protección de datos personales
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-12">
        
        {/* Identidad y Domicilio del Responsable */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <Building2 className="w-8 h-8" />
                Identidad y Domicilio del Responsable
              </h2>
            </div>
            
            <div className="p-8">
              <div className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-lg border-2 border-gray-200">
                <p className="text-gray-700 text-lg leading-relaxed mb-4">
                  El Responsable de los datos personales que usted proporciona es el <strong className="text-[#0b742f]">Centro de 
                  Estudios e Investigaciones para el Desarrollo Docente, CENID A.C.</strong>
                </p>
                <div className="flex items-start gap-3 text-gray-700">
                  <Globe className="w-6 h-6 text-[#0b742f] flex-shrink-0 mt-1" />
                  <div>
                    <p className="font-semibold mb-1">Domicilio:</p>
                    {direccion ? (
                      <>
                        <p>{direccion.calle}</p>
                        <p>{direccion.colonia},</p>
                        <p>{direccion.ciudad}, {direccion.estado} ({direccion.pais})</p>
                        {direccion.cp && <p>C.P. {direccion.cp}</p>}
                        <p>Tel. {direccion.telefono}</p>
                        <p>Correo electrónico: <a href={`mailto:${direccion.email}`}>{direccion.email}</a></p>
                        <p>Web: <a href={direccion.web} target="_blank" rel="noopener noreferrer">{direccion.web}</a></p>
                      </>
                    ) : (
                      <span>Cargando dirección...</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Datos Personales Tratados */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <div className="bg-gradient-to-r from-[#e87729] to-[#d96820] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <Database className="w-8 h-8" />
                Datos Personales y Datos Personales Sensibles Tratados por CENID
              </h2>
            </div>
            
            <div className="p-8">
              <div className="mb-8">
                <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg mb-6">
                  <div className="flex items-start gap-3">
                    <Info className="w-6 h-6 text-blue-600 flex-shrink-0 mt-1" />
                    <p className="text-gray-700 leading-relaxed">
                      CENID como parte de su registro de prospectos recabará y tratará datos personales de 
                      identificación, datos personales de contacto, datos personales académicos y en algunos 
                      casos datos laborales. Le informamos que para cumplir con las finalidades primarias y 
                      necesarias señaladas en el presente Aviso, <strong>CENID no recabará ni tratará datos personales sensibles.</strong>
                    </p>
                  </div>
                </div>

                <h3 className="text-2xl font-bold text-gray-900 mb-4">Tipos de datos recabados:</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {datosPersonales.map((dato, index) => (
                    <div 
                      key={index}
                      className="bg-gradient-to-r from-gray-50 to-white p-5 rounded-lg border-2 border-gray-200 hover:border-[#e87729] hover:shadow-md transition-all duration-200"
                    >
                      <div className="flex items-start gap-3">
                        <div className="flex-shrink-0">
                          <div className="bg-[#e87729]/10 p-2 rounded-full">
                            <UserCheck className="w-5 h-5 text-[#e87729]" />
                          </div>
                        </div>
                        <div className="flex-1">
                          <h4 className="font-bold text-gray-900 mb-1">{dato.tipo}</h4>
                          <p className="text-sm text-gray-600">{dato.ejemplos}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Finalidades del Tratamiento */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <FileText className="w-8 h-8" />
                Finalidades del Tratamiento de Datos Personales
              </h2>
            </div>
            
            <div className="p-8">
              <p className="text-lg text-gray-700 mb-6">
                CENID tratará sus datos personales para cumplir con las siguientes finalidades primarias y necesarias:
              </p>

              <div className="space-y-3 mb-6">
                {finalidadesPrimarias.map((finalidad, index) => (
                  <div 
                    key={index}
                    className="flex items-start gap-3 bg-gradient-to-r from-gray-50 to-white p-4 rounded-lg border-l-4 border-[#0b742f]"
                  >
                    <CheckCircle className="w-5 h-5 text-[#0b742f] flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">{finalidad}</p>
                  </div>
                ))}
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-r-lg">
                <div className="flex items-start gap-3">
                  <AlertCircle className="w-6 h-6 text-yellow-600 flex-shrink-0 mt-1" />
                  <p className="text-gray-700 leading-relaxed">
                    <strong>Importante:</strong> La negativa para el uso de sus datos personales para fines adicionales, 
                    no podrá ser un motivo para negarle los servicios solicitados o dar por terminada la relación 
                    establecida con nosotros.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Términos y Condiciones de Uso */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <div className="bg-gradient-to-r from-[#e87729] to-[#d96820] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <Scale className="w-8 h-8" />
                Términos y Condiciones de Uso
              </h2>
            </div>
            
            <div className="p-8">
              <div className="mb-6">
                <p className="text-gray-700 text-lg leading-relaxed mb-6">
                  Los términos y condiciones de uso constituyen el acuerdo entre el Centro de Estudios e 
                  Investigaciones para el Desarrollo Docente CENID A.C. y cualquier usuario interesado en nuestra 
                  página web <strong className="text-[#e87729]">www.cenid.org</strong>
                </p>
                
                <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-r-lg mb-6">
                  <p className="text-gray-700 leading-relaxed">
                    La utilización del sitio por parte del usuario implica su adhesión plena e incondicional a 
                    estos términos y condiciones de uso. El acceso y utilización del sitio tiene carácter 
                    <strong> gratuito</strong> para todos los usuarios.
                  </p>
                </div>
              </div>

              <div className="space-y-6">
                {terminosUso.map((termino, index) => (
                  <div key={index} className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-lg border-2 border-gray-200">
                    <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                      <CheckCircle className="w-6 h-6 text-[#e87729]" />
                      {termino.titulo}
                    </h3>
                    <p className="text-gray-700 leading-relaxed pl-8">
                      {termino.contenido}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Limitación de Responsabilidad */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <AlertCircle className="w-8 h-8" />
                Responsabilidad y Limitaciones
              </h2>
            </div>
            
            <div className="p-8">
              <p className="text-lg text-gray-700 mb-6">
                Hasta el máximo permitido por las leyes aplicables, el CENID no será responsable, en ningún caso, 
                por daños directos, especiales, incidentales, indirectos o consecuenciales que en cualquier forma 
                se deriven o se relacionen con:
              </p>

              <div className="space-y-3 mb-6">
                {responsabilidades.map((responsabilidad, index) => (
                  <div 
                    key={index}
                    className="flex items-start gap-3 bg-gradient-to-r from-gray-50 to-white p-4 rounded-lg border-l-4 border-[#0b742f]"
                  >
                    <AlertCircle className="w-5 h-5 text-[#0b742f] flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700">{responsabilidad}</p>
                  </div>
                ))}
              </div>

              <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-r-lg">
                <p className="text-gray-700 leading-relaxed">
                  <strong>Importante:</strong> El usuario es responsable de cualquier daño y/o perjuicio de cualquier 
                  naturaleza que ocasionara por incumplir estos términos de uso o cualquier normatividad aplicable, 
                  por lo que deslinda a el CENID de toda responsabilidad civil, penal, administrativa o de cualquier 
                  otra índole.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Requisitos para Alumnos */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#e87729]">
            <div className="bg-gradient-to-r from-[#e87729] to-[#d96820] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <Users className="w-8 h-8" />
                Convenio e Instructivo - Requisitos para Alumnos
              </h2>
            </div>
            
            <div className="p-8">
              <p className="text-gray-700 text-lg leading-relaxed mb-6">
                Cumpliendo con las disposiciones de la Secretaría de Comercio, Fomento Industrial y de Educación, 
                presentamos los requisitos y normas para precisar los costos educativos en este plantel.
              </p>

              <div className="space-y-3">
                {requisitosAlumnos.map((requisito, index) => (
                  <div 
                    key={index}
                    className="flex items-start gap-3 bg-gradient-to-r from-gray-50 to-white p-4 rounded-lg border-l-4 border-[#e87729]"
                  >
                    <div className="flex-shrink-0">
                      <div className="bg-[#e87729] text-white w-7 h-7 rounded-full flex items-center justify-center font-bold text-sm">
                        {index + 1}
                      </div>
                    </div>
                    <p className="text-gray-700 flex-1">{requisito}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Derechos del Usuario */}
        <section className="mb-12">
          <div className="bg-white rounded-lg shadow-xl overflow-hidden border-l-4 border-[#0b742f]">
            <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white p-6">
              <h2 className="text-3xl font-bold flex items-center gap-3">
                <Lock className="w-8 h-8" />
                Modificaciones y Legislación Aplicable
              </h2>
            </div>
            
            <div className="p-8">
              <div className="space-y-6">
                <div className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-lg border-2 border-gray-200">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <FileText className="w-6 h-6 text-[#0b742f]" />
                    Modificaciones al Convenio
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    El CENID se reserva el derecho de modificar los Términos y Condiciones de Uso de este convenio 
                    en cualquier momento, siendo efectivas dichas modificaciones de forma inmediata por medio de la 
                    publicación en el sitio del convenio actualizado. Cada vez que el usuario acceda al sitio se 
                    considerará como una aceptación absoluta a las modificaciones del presente convenio.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-lg border-2 border-gray-200">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <Scale className="w-6 h-6 text-[#0b742f]" />
                    Legislación Aplicable
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Este convenio estará sujeto y será interpretado de acuerdo con las leyes y ante los tribunales 
                    de la <strong>Ciudad de México, México</strong>.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-lg border-2 border-gray-200">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <CheckCircle className="w-6 h-6 text-[#0b742f]" />
                    Aceptación de los Términos
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Este documento de Términos y Condiciones de Uso constituye un acuerdo válido entre el usuario y 
                    el CENID. Si el usuario utiliza el sitio web y los servicios del CENID significa que ha leído, 
                    entendido, aceptado y consecuentemente acordado con el CENID los términos antes expuestos. 
                    En caso de no estar de acuerdo con ellos, el usuario NO deberá proporcionar ninguna información 
                    personal ni profesional, ni utilizar este servicio.
                  </p>
                </div>

                <div className="bg-gradient-to-r from-gray-50 to-white p-6 rounded-lg border-2 border-gray-200">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-center gap-2">
                    <Shield className="w-6 h-6 text-[#0b742f]" />
                    Derechos Reservados
                  </h3>
                  <p className="text-gray-700 leading-relaxed">
                    Cualquier derecho que no se haya conferido expresamente en este documento se entiende reservado 
                    al CENID. Una versión impresa de estos Términos y Condiciones de Uso será admisible como medio 
                    probatorio en cualquier procedimiento judicial y/o administrativo.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section>
          <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white rounded-lg shadow-xl p-8">
            <div className="text-center max-w-3xl mx-auto">
              <Shield className="w-12 h-12 mx-auto mb-4" />
              <h2 className="text-3xl font-bold mb-4">
                Protección de sus datos personales
              </h2>
              <p className="text-xl text-white/90 mb-4">
                En CENID nos comprometemos a proteger su privacidad y garantizar el uso responsable de sus datos personales.
              </p>
              <p className="text-lg text-white/80">
                Última actualización: Octubre 2025
              </p>
            </div>
          </div>
        </section>

      </div>
    </div> 
  );
};

export default AvisoPrivacidad;
